// GERADO a partir de packages/ui/tokens.json por packages/ui/scripts/gerar-tokens.mjs.
// Nao editar a mao: mudar o tokens.json e correr `pnpm --filter @growup/ui tokens`.

/** Cores da marca e cores fixas (nao mudam com o tema): cartas, fitas, medalha, calendario, PDF. */
export const CORES = {
  'brand-red': '#E10613',
  'brand-black': '#0B0B0D',
  'brand-charcoal': '#14161A',
  'brand-white': '#FFFFFF',
  'brand-grey': '#989898',
  'brand-grey-dark': '#2F2F2F',
  'card-user-from': '#6B6F76',
  'card-user-to': '#3C3F45',
  'card-user-edge': '#D2D4D8',
  'card-member-from': '#7A0C14',
  'card-member-to': '#2B0407',
  'card-member-muted': '#E8A9AE',
  'card-associate-from': '#E10613',
  'card-associate-to': '#8A030B',
  'card-streamer-badge': '#9146FF',
  'tier-platinum-from': '#F4F6F8',
  'tier-platinum-to': '#A9B4BE',
  'tier-gold-from': '#F6D77A',
  'tier-gold-to': '#B8892B',
  'tier-silver-from': '#E6E8EA',
  'tier-silver-to': '#8F959B',
  'tier-bronze-from': '#E3A16A',
  'tier-bronze-to': '#8C5226',
  'calendar-event': '#E10613',
  'calendar-giveaway': '#C99A06',
  'calendar-team-match': '#1F6FEB',
  'calendar-tournament': '#1A7F37',
  'calendar-stream': '#9146FF',
  'calendar-other': '#6E7781',
  'pdf-accent': '#E10613',
  'pdf-ink': '#14161A',
  'pdf-muted': '#5C6370',
  'pdf-line': '#D5D8DE',
  'browser-bar': '#0B0B0D',
} as const;

/** Efeitos das cartas: intensidade holografica, inclinacao e opacidades da textura. */
export const EFEITOS = {
  'holo-intensidade': 1,
  'holo-foil': 0.5,
  'holo-foil-associado': 0.75,
  'holo-inclinacao-x': 22,
  'holo-inclinacao-y': 26,
  'holo-zoom': 0.04,
  'carta-brilho': 0.32,
  'carta-reflexo': 0.16,
  'carta-favo': 0.07,
  'carta-riscas': 0.07,
  'carta-sombra': 0.45,
  'carta-barras': 0.18,
  'carta-silhueta': 0.45,
  'carta-contorno': 0.55,
} as const;
